import React from "react";
import styled from "styled-components";
import Input from "./Input";

interface Props {
  value: Option;
  onChange: (option: Option) => void;
}

interface Option {
  value: string;
  label: string;
}

export const TwoInputWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 10px;
`;

const OptionInput = (props: Props) => {
  const { value, onChange } = props;

  return (
    <TwoInputWrapper>
      <Input
        placeholder="Label"
        required
        value={value.label}
        onChange={(label) => onChange({ ...value, label })}
        autoFocus
      />
      <Input
        placeholder="Value"
        required
        value={value.value}
        onChange={(v) => onChange({ ...value, value: v })}
      />
    </TwoInputWrapper>
  );
};

export default OptionInput;
